export const ALL_STORES_ID = 'AllStores';

export const CONTACT_ID = 'contactId';